import * as Scrivito from "scrivito";

const InfoPopupWidget = Scrivito.provideWidgetClass("InfoPopupWidget", {
  attributes: {
    popupTitle: "string",
    popupSubtitle: "string",
    popupContent: "string",
    popupLink: "link",
  },
});

export default InfoPopupWidget;
